import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-allow-popup-dialog',
  templateUrl: './allow-popup-dialog.component.html',
  styleUrls: ['./allow-popup-dialog.component.css']
})
export class AllowPopupDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AllowPopupDialogComponent>
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/allow-popup-dialog/allow-popup-dialog.component.ts